import React from "react";
import "./index.css";
const imageFood = require("../../../assets/media/retailers/dinner-table.png");
const imageBeauty = require("../../../assets/media/retailers/beauty.png");
const imageFashion = require("../../../assets/media/retailers/fashion.png");
const imageHome = require("../../../assets/media/retailers/armchair.png");
const imageTech = require("../../../assets/media/retailers/responsive.png");
const imageEntertainment = require("../../../assets/media/retailers/ticket.png");
const imageTop20 = require("../../../assets/media/retailers/star.png");
const imageSupermarkets = require("../../../assets/media/retailers/supermarkets.png");
const imageTravel = require("../../../assets/media/retailers/travel.png");
const imageHealth = require("../../../assets/media/retailers/heart.png");
class FilterTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offers: [],
    };
  }
  render() {
    const { filter_View, tag } = this.props;
    return (
      <div className="filter_div">
        <div
          className={`field ${tag === "Top 20" ? "active" : ""}`}
          onClick={() => filter_View("Top 20")}
        >
          <div>
            <img src={imageTop20} width="50%"></img>
            <p>Top 20</p>
          </div>
        </div>
        <div
          className={`field ${tag === "Supermarkets" ? "active" : ""}`}
          onClick={() => filter_View("Supermarkets")}
        >
          <div>
            <img src={imageSupermarkets} width="50%"></img>
            <p>Supermarkets</p>
          </div>
        </div>
        <div
          className={`field ${tag === "Home" ? "active" : ""}`}
          onClick={() => filter_View("Home")}
        >
          <div>
            <img src={imageHome} width="50%"></img>
            <p>Home</p>
          </div>
        </div>
        <div
          className={`field ${tag === "Fashion" ? "active" : ""}`}
          onClick={() => filter_View("Fashion")}
        >
          <div>
            <img src={imageFashion} width="50%"></img>
            <p>Fashion</p>
          </div>
        </div>

        <div
          className={`field ${tag === "Tech" ? "active" : ""}`}
          onClick={() => filter_View("Tech")}
        >
          <div>
            <img src={imageTech} width="50%"></img>
            <p>Tech</p>
          </div>
        </div>
        <div
          className={`field ${tag === "Beauty" ? "active" : ""}`}
          onClick={() => filter_View("Beauty")}
        >
          <div>
            <img src={imageBeauty} width="50%"></img>
            <p>Beauty</p>
          </div>
        </div>
        <div
          className={`field ${tag === "Food & Drink" ? "active" : ""}`}
          onClick={() => filter_View("Food & Drink")}
        >
          <div>
            <img src={imageFood} width="50%"></img>
            <p>Food & Drink</p>
          </div>
        </div>
        <div
          className={`field ${tag === "Entertainment" ? "active" : ""}`}
          onClick={() => filter_View("Entertainment")}
        >
          <div>
            <img src={imageEntertainment} width="50%"></img>
            <p>Entertainment</p>
          </div>
        </div>
        <div
          className={`field ${tag === "Travel" ? "active" : ""}`}
          onClick={() => filter_View("Travel")}
        >
          <div>
            <img src={imageTravel} width="50%"></img>
            <p>Travel</p>
          </div>
        </div>
      </div>
    );
  }
}

export default FilterTab;



// WEBPACK FOOTER //
// ./src/screens/super_offers/components/FilterTab.js